export default __webpack_public_path__ + "static/media/login_overlay.91b1665b.svg";